import Label from '../../../../components/ui/Label';
import Input from '../../../../components/ui/Input';
import Select, { type SelectOption } from '../../../../components/ui/Select';
import type { PixKeyType } from '../../../../domain/pix/types';

export const PIX_TYPE_OPTIONS: SelectOption[] = [
    { value: 'cpf', label: 'CPF' },
    { value: 'cnpj', label: 'CNPJ' },
    { value: 'phone', label: 'Telefone' },
    { value: 'email', label: 'E-mail' },
    { value: 'evp', label: 'Chave aleatória (EVP)' },
];

interface PixKeyFormFieldsProps {
    type: PixKeyType;
    pixKey: string;
    name: string;
    onTypeChange: (v: PixKeyType) => void;
    onPixKeyChange: (v: string) => void;
    onNameChange: (v: string) => void;
    disabled?: boolean;
}

export function PixKeyFormFields({
    type,
    pixKey,
    name,
    onTypeChange,
    onPixKeyChange,
    onNameChange,
    disabled,
}: PixKeyFormFieldsProps) {
    return (
        <>
            <div>
                <Label htmlFor="pix-type" required>Tipo de chave</Label>
                <Select
                    id="pix-type"
                    value={type}
                    onChange={(e) => onTypeChange(e.target.value as PixKeyType)}
                    options={PIX_TYPE_OPTIONS}
                    disabled={disabled}
                />
            </div>

            <div>
                <Label htmlFor="pix-key" required>Chave PIX</Label>
                <Input
                    id="pix-key"
                    value={pixKey}
                    onChange={(e) => onPixKeyChange(e.target.value)}
                    placeholder="ana@empresa.com"
                    disabled={disabled}
                />
            </div>

            <div>
                <Label htmlFor="pix-name" required>Nome do titular</Label>
                <Input
                    id="pix-name"
                    value={name}
                    onChange={(e) => onNameChange(e.target.value)}
                    placeholder="Ana Souza"
                    disabled={disabled}
                />
            </div>
        </>
    );
}
